module.exports = __webpack_public_path__ + "img/布尔运算2.4d2b4fc3.svg";